/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Label } from '@bottlebooks/gatsby-design-system';
import { findRoomByStandName } from '@bottlebooks/gatsby-plugin-california-pdf/src/templates/VieVinum/helpers/rooms';
import { Link } from '@bottlebooks/gatsby-theme-base';
import React from 'react';
import { jsx } from 'theme-ui';

export * from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductStand';

/**
 *
 * @param {object} props
 * @param {object} props.stand
 * @param {object} [props.exhibitor]
 * @param {string} [props.to]
 * @param {string} [props.href]
 * @param {() => void} [props.onClick]
 */
export default function ProductStand({
  stand,
  exhibitor,
  to,
  href,
  onClick,
  ...rest
}) {
  // Finding the room directly so we don't have to add the fragment everywhere.
  const room = findRoomByStandName(stand?.name);
  return (
    <Label {...rest}>
      <Link
        to={to}
        onClick={onClick}
        href={href}
        sx={{ color: room?.colors?.primary }}
      >
        {[stand?.name, exhibitor?.name].filter(Boolean).join(' — ') || (
          <React.Fragment>&nbsp;</React.Fragment>
        )}
      </Link>
    </Label>
  );
}
